import { get } from "http";
import { environment } from "src/environments/environment";

const base_url = environment.base_url;


export const apiEnpoints = {

    ///User management
    addSystemUser:`${base_url}/api/SystmeUser/add/user`,
    getAllSystemUsers:`${base_url}/all/user`,
    logout:`${base_url}/api/Authentication/revoke/user/token`,
    changePassword:`${base_url}/api/SystmeUser/user/change/password`,
    getBuyerUsers:`${base_url}/api/SystmeUser/all/buyers/users`, 
    addBuyerUser:`${base_url}/api/Buyer/create/buyer/user`,
    deleteUserById:`${base_url}/api/SystmeUser/remove/user`,

    ///Buyer management
    getAllBuyer:`${base_url}/all/buyer`,
    addBuyer: `${base_url}/api/Buyer/add/buyer`,
    getbyersuserid: `${base_url}/api/Buyer/all/buyers/userid`,
    getPatternDataByBuyerId: `${base_url}/api/OPSPattern/all/pattern/buyerid`,

    //shipment
    getBuyerById: `${base_url}/api/Buyer/all/buyer/specificid`,
    submitShipmentdetails: `${base_url}/api/Shipemnt/add/shipment`,
    getShipment: `${base_url}/api/Shipemnt/all/shipment/specificid`,

    //local Agent
    submitAgent: `${base_url}/api/LocalAgent/add/agent`,
    getlocalagentinByerid: `${base_url}/api/LocalAgent/all/localagent/buyerid`,

    //material
    getMaterial: `${base_url}/api/pattern/allMaterial/patternId`,

    //emblishment
    getEmblishment: `${base_url}/api/OPSPattern/allemblishment/patternId`,
   
    //vl
    getSelectedTmpvl: `${base_url}/api/pattern/all/Vl/patternId`,
    getVLEmblishment: `${base_url}/api/OPSPattern/allvlemblishment/vlId`,
    submitVlDetails:`${base_url}/api/pattern/add/desing/tmp`,
    getInitialData: `${base_url}/api/OPSPattern/vl/init/data`,
    getVlById: `${base_url}/edit/vl/details`,
    getCostMaterials:`${base_url}/api/pattern/get/additional/cost/materials`,
    saveCategory:`${base_url}/api/pattern/save/vl/etc/category`,


    //size
    getAllSize: `${base_url}/all/size`,
    submitSizeDetails: `${base_url}/api/pattern/add/sizedetails`,
    submitSize: `${base_url}/api/pattern/add/size`,
     
    //podetails
    getpoforvlid: `${base_url}/api/po/po/vlId`,
    getInitPoDetails: `${base_url}/api/po/init/data`,


    //pattern
    getAllSpecialDetail: `${base_url}/all/SpecialDetail`,
    getFabricData:`${base_url}/all/Materials/fabric`,
    getMaterialData:`${base_url}/all/accessories`,
    getSizeDataById:`${base_url}/api/OPSPattern/sizes/for/sizeset`,
    getAllSublimations: `${base_url}/all/sublimations`,
    getPatterninByerid: `${base_url}/api/OPSPattern/all/pattern/buyerid`,
    getPatternById: `${base_url}/api/OPSPattern/edit/selected/pattern/data`,

    //sales order
    getBasicDataForSalesOrder: `${base_url}/api/ScreenPrint/get/screen-print/basic/details`,
    submitSalesOrder: `${base_url}/api/ScreenPrint/add/screen-print/sales/order`,
    getSalesOrderBySearch: `${base_url}/api/ScreenPrint/get/screen-print/sales/order/number`,
    getAllSalesOrders:`${base_url}/api/ScreenPrint/get/screen-print/sales/order/details`,


    //Gate Pass
    getBasicDataForGatePass:`${base_url}/api/ScreenPrint/get/screen-print/bundles/basic/details`,
    submitGatePassOrder: `${base_url}/api/ScreenPrint/add/screen-print/sales/order/bundles`,
    getGetPassBySearch: `${base_url}/api/ScreenPrint/get/screen-print/gatepass/numberr`,
    getAllGatePasses:`${base_url}/api/ScreenPrint/get/screen-print/sales/order/bundle/details`,
    getBarcodeData:`${base_url}/api/ScreenPrint/get/selected/bundle/transaction/details`,

    //Barcode reader
    getAllDepartment:`${base_url}/api/ScreenPrint/get/bundle/departments`,
    addNewDepartment:`${base_url}/api/ScreenPrint/save/bundle/department`,
    getDepartmentById:`${base_url}/api/ScreenPrint/get/selected/bundle/department`,
    validateEmployeeId:`${base_url}/api/ScreenPrint/validate/employee/id`,
    getBarcodeStatus:`${base_url}/api/ScreenPrint/check/bundle/transaction/details`,
    submitInput:`${base_url}/api/ScreenPrint/save/bundle/transaction/input`,
    submitOutput:`${base_url}/api/ScreenPrint/save/bundle/transaction/output`,

    //PO V2
    getPOV2InitData: `${base_url}/api/po/init/data/v2`,
    getPOV2InitDataPopUp: `${base_url}/api/po/popup/init/data`,
    savePoDetails:`${base_url}/api/po/save/po/details`,
    getAllPurchaseOrder:`${base_url}/all/purchasingorder`,
    getAllMasterPurchaseOrder:`${base_url}/all/master-po-details`,
    getAmountDataByVl:`${base_url}/api/pattern/get/po/vl/price/data`,
    getPoById:`${base_url}/all/po/master`,
    getQuatationData:`${base_url}/api/po/quotation`,
    getInvoiceData:`${base_url}/api/po/invoice`,
    getDashboardData:`${base_url}/api/po/dashboard/basic/data`,

    //Summary Weekly
    getWeeklySummary:`${base_url}/api/OPSPattern/get/buyer/dashboard/report`,

    getVlByByerId: `${base_url}/api/pattern/all/Vl/Buyer/buyerId`,

    getDataofFirmOrders:`${base_url}/api/OPSPattern/get/buyer/dashboard/report/week/firmOrders`,
    getDataOfTotalOrders:`${base_url}/api/OPSPattern/get/buyer/dashboard/report/week/orders`,

}
